module.exports = __webpack_public_path__ + "static/media/Bas Bas Instant kafa 1.44cd99df.jpg";